import {Button} from '@material-ui/core';
import React from 'react';
import './UserAccountNotFound.sass';
import {logoutISAM} from "../ducks/refreshToken";
import {useDispatch} from "react-redux";

const UserAccountNotFound = () => {
  const dispatch = useDispatch();

  return (
    <div className="user-account-not-found">
      <p>Sorry, you do not appear to have been granted access to this website. Please contact your administrator.</p>
      <Button onClick={() => dispatch(logoutISAM())} variant="contained" color="primary">
        Return To Login
      </Button>
    </div>
  );
};

export default UserAccountNotFound;
